export default __webpack_public_path__ + "static/media/mw17.eb8c2a47.webp";